import { type NavigateOptions, useSearchParams } from 'react-router-dom';

const PAGE_PARAM = 'page';

const parsePage = (value: string | null) => {
  const page = Number(value);
  return Number.isInteger(page) && page > 1 ? page : 1;
};

export function usePageSearchParam() {
  const [searchParams, setSearchParams] = useSearchParams();
  const page = parsePage(searchParams.get(PAGE_PARAM));

  const setPage = (next: number, options?: NavigateOptions) =>
    setSearchParams((current) => {
      const params = new URLSearchParams(current);
      if (next > 1) params.set(PAGE_PARAM, String(next));
      else params.delete(PAGE_PARAM);
      return params;
    }, options);

  return [page, setPage] as const;
}
